import { ActionTree } from 'vuex';
import { ISearchResult } from '@/topbar/search/types/search-result';
import {
  ESearchAction,
  ESearchMutation,
  getDefaultState,
} from '@/topbar/search/store/search.constants';
import { ISearchState } from '@/topbar/search/store/search.types';
import { RootState } from '@/store/store';
import { SearchService } from '@/api/search/services/search.service';
import { translate } from '@/helpers/translation.helper';
import { IDocument } from '@lib-shared/types/Document';
import { IUser } from '@/types/User';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';

export const actions: ActionTree<ISearchState, RootState> = {
  async [ESearchAction.Search](
    { commit, dispatch },
    { query, showAll, showTeam }: { query: string; showAll: boolean; showTeam: boolean }
  ) {
    commit(ESearchMutation.SetLoaded, false);
    commit(ESearchMutation.SetLoading, true);
    commit(ESearchMutation.SetQuery, query);
    try {
      const result: any = await SearchService.search(query, showAll, showTeam);
      const documents: IDocument[] = result.documents ? result.documents : [];
      const contacts: IUser[] = result.contacts ? result.contacts : [];
      const searchResult: ISearchResult = { documents, contacts };
      dispatch(ESearchAction.SearchSuccess, searchResult);
    } catch (error) {
      dispatch(ESearchAction.SearchFailed);
    }
  },
  [ESearchAction.SearchSuccess]({ commit }, result: ISearchResult) {
    commit(ESearchMutation.SetResult, result);
    commit(ESearchMutation.SetLoaded, true);
    commit(ESearchMutation.SetLoading, false);
  },
  [ESearchAction.SearchFailed]({ dispatch, commit }) {
    dispatch(
      `${alertNamespace}/${EAlertAction.ShowDanger}`,
      translate('failed-to-retrieve-search-results'),
      {
        root: true,
      }
    );
    commit(ESearchMutation.SetLoading, false);
  },
  [ESearchAction.ShowSearchInput]({ commit }, show: boolean) {
    commit(ESearchMutation.SetSearchInputVisibility, show);
  },
  [ESearchAction.ClearData]({ commit }) {
    commit(ESearchMutation.SetState, { ...getDefaultState() });
  },
};
